export default __webpack_public_path__ + "static/media/qBittorrent.b65e8e28.svg";